import React, { useContext } from "react";


//functions
import {
  _t,
  formatPrice,
  getSystemSettings,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";
import { SettingsContext } from "../../../../../contexts/Settings";
import "./stock.css"
import { useGeneralHooks } from "../../../../../hooks/generalHooks";

const PurchaseOrderPrint = ({
  name,
  printDetailView,
  newRow,
  PrintView
 }) => {
    const { t } = useTranslation();
    const { enableStockBrand } = useGeneralHooks();
    const {
      //common
      generalSettings,
    } = useContext(SettingsContext);

    const checkBrandColSpan = name === "Goods Received Note" && enableStockBrand ? 5 : name === "Goods Received Note" ? 4 : 3;

    return (
        <>
        {/* print */}
        <div className="d-none">
            <div ref={PrintView}>
            {printDetailView && (
                <div className="fk-print" style={{margin:"20px"}}>
                    <div className="row">
                        <div className="col-12">
                            <div className="mx-auto" style={{ width: "90px" }}>
                            <img
                                src={`${getSystemSettings(generalSettings,"type_logo")}`}
                                style={{ width: "100%" }}
                            />
                            </div>
                            <div className="my-2 xlg-print-text-stock print-text-stock text-center text-capitalize print-text-stock--bold">
                                {getSystemSettings(generalSettings, "siteName")}
                            </div>
                            <div className="my-2 xlg-print-text-stock print-text-stock text-center text-capitalize print-text-stock--bold">
                                {printDetailView.branch && printDetailView.branch?.name}
                            </div>
                            <div className="my-2 xlg-print-text-stock print-text-stock text-center text-capitalize print-text-stock--bold">
                                {name}
                            </div>

                            <div className="mt-4 my-2 print-text-stock print-text-stock--bold row text-capitalize">
                                <div className="col-6">Document No.: {printDetailView?.doc_id}</div>
                                <div className="col-6">Doc Date : {printDetailView?.date && printDetailView?.date?.toDateString()}</div>
                            </div>

                            
                            {(printDetailView.supplier || printDetailView?.ref_doc || printDetailView?.delivery_date || printDetailView.remarks) ? 
                            <div className="print-text-stock text-capitalize print-text-stock--bold row">
                                {printDetailView?.delivery_date ?
                                    <div className="my-2 col-6">Delivery Date :  {printDetailView?.delivery_date?.toDateString()}</div>
                                : ""}
                                <div className="my-2 col-6">
                                    Supplier Name :{" "}
                                    {printDetailView.supplier && printDetailView.supplier?.name}
                                </div>
                                {printDetailView?.ref_doc ?
                                    <div className="my-2 col-6">
                                        Document Ref :{" "}
                                        {printDetailView.ref_doc}
                                    </div>
                                    : ""
                                }
                                {printDetailView.remarks ? 
                                    <div className="my-2 col-6">
                                        Description :{" "}
                                        {printDetailView.remarks}
                                    </div>
                                : ""}
                            </div> : ""}
                            
                            {newRow !== null && [
                            newRow.length > 0 && (
                                <div className=" mt-3">
                                    <table className="table table-bordered-sm table-hover print-text-stock">
                                        <thead className="align-middle">
                                        <tr>
                                            <th
                                            scope="col"
                                            className="text-capitalize align-middle text-center border-dark border-1 border table_child_ordertype"
                                            >
                                            {_t(t("Name"))}
                                            </th>

                                            {enableStockBrand && name === "Goods Received Note" && ( 
                                                <th
                                                scope="col"
                                                className="text-capitalize align-middle text-center border-dark border-1 border table_child_ordertype"
                                                >
                                                {_t(t("Brand"))}
                                                </th>
                                            )}

                                            {
                                                name === "Goods Received Note" && (
                                                    <th
                                                    scope="col"
                                                    className="text-capitalize align-middle text-center border-dark border-1 border"
                                                    >
                                                    {_t(t("PR Qty"))}
                                                    </th> 
                                                )
                                            }
                                            
                                            <th
                                            scope="col"
                                            className="text-capitalize align-middle text-center border-dark border-1 border"
                                            >
                                            {_t(t("Qty"))}
                                            </th>

                                            <th
                                            scope="col"
                                            className="text-capitalize align-middle text-center border-dark border-1 border"
                                            >
                                            {_t(t("Unit"))}
                                            </th>

                                            <th
                                            scope="col"
                                            className="text-capitalize align-middle text-center border-dark border-1 border"
                                            >
                                            {_t(t("Rate"))}
                                            </th>

                                            <th
                                            scope="col"
                                            className="text-capitalize align-middle text-center border-dark border-1 border"
                                            >
                                            {_t(t("Amount"))}
                                            </th>
                                            {
                                            newRow[0]?.total ? (
                                                <>
                                                    <th
                                                        scope="col"
                                                        className="text-capitalize align-middle text-center border-dark border-1 border"
                                                    >
                                                        {_t(t("Discount"))}
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        className="text-capitalize align-middle text-center border-dark border-1 border"
                                                    >
                                                        {_t(t("Tax"))}
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        className="text-capitalize align-middle text-center border-dark border-1 border"
                                                    >
                                                        {_t(t("Total"))}
                                                    </th>
                                                </>
                                            ) : "" 
                                            }
                                        </tr>
                                        </thead>

                                        <tbody className="align-middle">
                                        {newRow?.length && newRow?.map((ingredientItem, index) => {
                                            return (
                                            <tr className="align-middle" key={index}>
                                                <td className="text-capitalize border-dark border-1 align-middle text-center">
                                                {ingredientItem.item_name}
                                                </td>

                                                {enableStockBrand && name === "Goods Received Note" && (
                                                    <td className="text-capitalize border-dark border-1 align-middle text-center">
                                                        {ingredientItem?.brand_name ?? "-"}
                                                    </td>
                                                )}

                                                {
                                                    name === "Goods Received Note" && (
                                                        <td
                                                        scope="col"
                                                        className="text-capitalize align-middle text-center border-dark border-1 border"
                                                        >
                                                        {ingredientItem.po_qty}
                                                        </td> 
                                                    )
                                                }

                                                <td className="text-capitalize border-dark border-1 align-middle text-center">
                                                {ingredientItem.qty}
                                                </td>

                                                <td className="text-capitalize border-dark border-1 align-middle text-center">
                                                {ingredientItem.unit_name}
                                                </td>

                                                {ingredientItem?.rate ? 
                                                <td className="text-capitalize border-dark border-1 align-middle text-center">                                     
                                                {ingredientItem?.rate}
                                                </td> : null}

                                                <td className="border-dark border-1 align-middle text-center">
                                                {formatPrice(
                                                    ingredientItem.amount
                                                )}
                                                </td> 
                                                {
                                                newRow[0]?.total ? (
                                                    <>
                                                        <td className="border-dark border-1 align-middle text-center">
                                                            {formatPrice(
                                                                ingredientItem.discount
                                                            )}
                                                        </td> 
                                                        <td className="border-dark border-1 align-middle text-center">
                                                            {formatPrice(
                                                                ingredientItem.tax
                                                            )}
                                                        </td> 
                                                        <td className="border-dark border-1 align-middle text-center">
                                                            {formatPrice(
                                                                ingredientItem.total
                                                            )}
                                                        </td> 
                                                    </>
                                                    ) : "" 
                                                }                                   
                                            </tr>
                                            );
                                        })}
                                        </tbody>
                                        
                                        <tbody className="align-middle">
                                            <tr>
                                                <th
                                                scope="col"
                                                colSpan={checkBrandColSpan}
                                                className="text-capitalize align-middle text-center border-dark border-1 border"
                                                ></th>
                                                <th
                                                scope="col"
                                                className="text-capitalize align-middle text-center border-dark border-1 border"
                                                >
                                                {_t(t("Total"))}
                                                </th>
                                        
                                                <th
                                                scope="col"
                                                className="text-capitalize align-middle text-center border-dark border-1 border"
                                                >
                                                    {printDetailView.total_amount ?
                                                    parseFloat(printDetailView.total_amount).toFixed(2) :
                                                    ""}
                                                </th>
                                                {
                                                printDetailView?.net_amount ? (
                                                    <>
                                                        <th
                                                        scope="col"
                                                        className="text-capitalize align-middle text-center border-dark border-1 border"
                                                        >
                                                            {printDetailView?.total_discount ?
                                                            parseFloat(printDetailView.total_discount).toFixed(2) :
                                                            ""}
                                                        </th>
                                                        <th
                                                        scope="col"
                                                        className="text-capitalize align-middle text-center border-dark border-1 border"
                                                        >
                                                            {printDetailView?.total_tax ?
                                                            parseFloat(printDetailView.total_tax).toFixed(2) :
                                                            ""}
                                                        </th>
                                                        <th
                                                        scope="col"
                                                        className="text-capitalize align-middle text-center border-dark border-1 border"
                                                        >
                                                            {printDetailView.net_amount ?
                                                            parseFloat(printDetailView.net_amount).toFixed(2) :
                                                            ""}
                                                        </th>
                                                    </>
                                                    ) : "" 
                                                }  
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            ),
                            ]}
                            {
                                name === "Purchase Order" && (
                                    <div className="mt-5 row">
                                        <div className="mt-5 col-12"></div>
                                        <div className="mt-5 col-12"></div>
                                        <div className="mt-5 col-12"></div>
                                        <div className="col-6 row">
                                        <div className="col-4 d-flex align-items-end">Approved By </div> 
                                        <div className="col-8 border-bottom border-1 border-dark"></div>
                                        </div>
                                        <div className="col-6 row">
                                        <div className="col-4 d-flex align-items-end">Manager Procurement </div> 
                                        <div className="col-8 border-bottom border-1 border-dark"></div>
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>
            )}
            </div>
        </div>
        </>
    )
}

export default PurchaseOrderPrint
